<template>
  <div class="GameRecommend">
    <div class="topic">
      <div class="topic1" v-if="recommendList[0]!=null"
           @click="toDetail(recommendList[0])">
        <p class="title1">{{ recommendList[0].name }}</p>
        <p class="tag1">{{ recommendList[0].name }}</p>
        <!--        <div class="star_content">-->

        <!--        </div>-->
        <div class="get1 btn_get">{{$t('获取')}}</div>
      </div>
      <img src="../../assets/img/motuo.png" alt="" class="motorcycle">
      <div class="topic2" v-if="recommendList[1]!=null"
           @click="toDetail(recommendList[1])">
        <p class="title2">{{ recommendList[1].name }}</p>
        <p class="tag2">{{ recommendList[1].name }}</p>

        <div class="get2 btn_get">{{$t('获取')}}</div>
        <img class="avatar1" :src="recommendList[1].icon" alt=""/>
      </div>
      <div class="topic3" v-if="recommendList[2]!=null"
           @click="toDetail(recommendList[2])">
        <p class="title3">{{ recommendList[2].name }}</p>
        <p class="tag3">{{ recommendList[2].name }}</p>

        <div class="get3 btn_get">{{$t('获取')}}</div>
        <img class="avatar2" :src="recommendList[2].icon" alt=""/>
      </div>
    </div>
    <p class="hot_games">热门游戏 / Trending Games</p>
    <div class="hot_games_top2">
      <div class="item_game_top game_left" v-if="recommendList[3]!=null"
           @click="toDetail(recommendList[3])">
        <img :src="recommendList[3].icon" alt="" class="hot_game_avatar">
        <div class="name">{{ recommendList[3].name }}</div>
        <div class="type">{{$t('推荐')}}</div>

        <div class="bottom_info">
          <img src="../../assets/img/download.png" alt="" class="download">
          <div class="download_count"></div>
          <div class="btn_get1 hot_game_get">{{$t('获取')}}</div>
        </div>
      </div>
      <div class="item_game_top game_right" v-if="recommendList[4]!=null"
           @click="toDetail(recommendList[4])">
        <img :src="recommendList[4].icon" alt="" class="hot_game_avatar">
        <div class="name">{{ recommendList[4].name }}</div>
        <div class="type">{{$t('推荐')}}</div>

        <div class="bottom_info">
          <img src="../../assets/img/download.png" alt="" class="download">
          <div class="download_count"></div>
          <div class="btn_get1 hot_game_get">{{$t('获取')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GameRecommend",
  props: {
    recommendList: {
      type: Array,
      required: true
    }
  },
  mounted() {
    console.log("推荐模块")
    console.log(this.recommendList)
  },
  methods: {
    toDetail: function (item) {
      this.$router.push({path: '/game_detail', query: {item: item, type: "推荐"}})
    },
  }
}
</script>

<style scoped lang="less">
.topic {
  padding: 10px;
  overflow: hidden;
  position: relative;

  .motorcycle {
    width: 31%;
    height: 114px;
    position: absolute;
    left: 6.5rem;
    top: 92px;
  }

  .topic1 {
    width: 52%;
    height: 191px;
    background: linear-gradient(-30deg, #449AFD, #0D5CFF);
    box-shadow: 0px 15px 26px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    float: left;
    position: relative;

    .title1 {
      height: 17px;
      font-size: 18px;
      font-family: Source Han Sans HW SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 23px;
      margin-top: 35px;
      margin-left: 18px;
    }

    .tag1 {
      height: 14px;
      font-size: 14px;
      font-family: Source Han Sans HW SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 23px;
      opacity: 0.3;
      margin-top: 10px;
      margin-left: 18px;
    }

    .star_content {
      width: 61px;
      height: 14px;
      background: #123044;
      opacity: 0.85;
      margin-left: 20px;
      margin-top: 10px;
      border-radius: 10px;
    }

    .get1 {
      width: 56px;
      height: 18px;

      font-size: 9px;
      font-family: Source Han Sans HW SC;
      font-weight: 400;
      color: #4184D2;
      position: absolute;
      left: 20px;
      bottom: 12px;
    }
  }

  .topic2 {
    width: 44%;
    height: 105px;
    background: linear-gradient(-30deg, #FBC33A, #FDA400);
    box-shadow: 0px 15px 26px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    float: right;
    position: relative;

    .title2 {

      font-size: 15px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 17px;
      display: inline-block;
      position: absolute;
      left: 15px;
      top: 18px;

    }

    .tag2 {
      width: 90px;
      font-size: 10px;
      font-family: Source Han Sans HW SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 17px;
      opacity: 0.3;
      position: absolute;
      left: 15px;
      top: 39px;
    }
  }
}


.btn_get {
  background-image: url("../../assets/img/bg_get.png");
  background-size: 100%;
  text-align: center;
  line-height: 18px;

  width: 18px;
  height: 9px;
  font-size: 9px;
  font-family: Source Han Sans HW SC;
  font-weight: 400;
  color: #4184D2;

}


.topic2 .get2 {
  width: 56px;
  height: 18px;

  font-size: 9px;
  font-family: Source Han Sans HW SC;
  font-weight: 400;
  color: #4184D2;
  position: absolute;
  bottom: 10px;
  right: 16px;
}

.topic2 .avatar1 {
  width: 39px;
  height: 39px;
  position: absolute;
  top: 14px;
  right: 18px;
}

.topic3 {
  width: 44%;
  height: 76px;
  background: linear-gradient(-30deg, #14E2E0, #11BCCA);
  box-shadow: 0px 15px 26px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  float: right;
  margin-top: 11px;
  position: relative;
}

.topic3 .title3 {

  height: 16px;
  font-size: 14px;
  font-family: Source Han Sans HW SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 17px;
  position: absolute;
  left: 14px;
  top: 19px;

}

.topic3 .tag3 {

  height: 10px;
  font-size: 10px;
  font-family: Source Han Sans HW SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 17px;
  opacity: 0.3;
  position: absolute;
  left: 15px;
  bottom: 27px;
}

.topic3 .get3 {
  width: 55px;
  height: 18px;
  opacity: 0.85;
  position: absolute;
  right: 12px;
  bottom: 8px;
}

.topic3 .avatar2 {
  width: 39px;
  height: 39px;
  position: absolute;
  top: 7px;
  right: 18px;
}

.hot_games {

  height: 14px;
  font-size: 12px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #000000;
  line-height: 10px;
  margin-top: 8px;
  margin-left: 15px;
}

.hot_games_top2 {
  margin-top: 16px;
}

.item_game_top {
  width: 46%;
  height: 97px;
  background: #FFFFFF;
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  display: inline-block;
  overflow: hidden;
  position: relative;

  .name {
    position: absolute;
    height: 12px;
    font-size: 12px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 12px;
    position: absolute;
    left: 64px;
    margin-top: 10px;
  }

  .hot_game_get {
    width: 61px;
    height: 20px;
    background-image: url("../../assets/img/item_list_get.png");
    background-size: 100%;
    text-align: center;
    line-height: 19px;
    margin-right: 7px;
  }

  .type {
    height: 11px;
    font-size: 11px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 12px;
    opacity: 0.8;

    position: absolute;
    left: 64px;
    margin-top: 28px;
  }

}

.hot_game_avatar {
  width: 49px;
  height: 49px;
  display: block;
  margin-top: 8px;
  margin-left: 8px;
  float: left;
}

.bottom_info {
  clear: both;
  padding-left: 9px;
  padding-top: 10px;
  position: relative;

  .download {
    width: 22px;
    height: 21px;
  }

  .download_count {
    left: 40px;
    bottom: 10px;
    position: absolute;

    height: 12px;
    font-size: 12px;
    font-family: Source Han Sans HW SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 10px;
  }

  .btn_get1 {
    font-size: 11px;
    font-family: Source Han Sans HW SC;
    font-weight: bold;
    color: #4184D2;
    position: absolute;
    right: 0;
    bottom: 4px;
  }
}

.game_left {
  margin-right: 1%;
  margin-left: 10px;
}

.game_right {
  margin-left: 1%;
  margin-right: 10px;
  float: right;
}
</style>
